import { AlertDialogAction } from '@/components/ui/alert-dialog';
import { buttonVariants } from '../ui/button';
import { CommonAlertModal, type AlertType } from './common-alert-modal';

interface Props {
  open: boolean;
  type: AlertType;
  title?: string;
  message: string;
  onClose: () => void;
  buttonText?: string;
  size?: 'default' | 'sm';
}

export function AlertModal({
  open,
  type,
  title,
  message,
  onClose,
  buttonText = 'OK',
  size = 'default',
}: Props) {
  return (
    <CommonAlertModal
      open={open}
      onOpenChange={open => {
        if (!open) {
          onClose();
        }
      }}
      type={type}
      title={title}
      message={message}
      size={size}
      footerContent={
        <div className="flex w-full sm:justify-center">
          <AlertDialogAction onClick={onClose} className={buttonVariants()}>
            {buttonText}
          </AlertDialogAction>
        </div>
      }
    />
  );
}
